export const PATHNAME = 'signup-hubspot';
export const getRootUrl = () => `/${PATHNAME}`;